<template>
  <div
    class="full-width full-height d-flex justify-center align-center flex-column"
  >
    <v-icon size="50">mdi-alert</v-icon>
    <p class="text-center text-subtitle-1">
      Slow or no internet connection.<br />
      Please check your internet settings or reload this page
    </p>
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>

<style scoped></style>
